/**
 * ダイアログメッセージを表示します。
 * Updated: 2026/10/07
 *
 * 使用例:
 * ```
 * mtapp.modalMsg({
 *     type: 'info',
 *     title: 'MTAppjQuery へようこそ！',
 *     content: '<h3>MTAppjQuery</h3><p class="mb-0">さらに機能が充実した MTAppjQuery で顧客満足度を高めましょう！</p>',
 *     callbacks: [{
 *         type: 'shown.bs.modal',
 *         action: function () {
 *             alert('shown.bs.modal');
 *         }
 *     }, {
 *         type: 'hide.bs.modal',
 *         action: function () {
 *             alert('hide.bs.modal');
 *         }
 *     }]
 * });
 * ```
 *
 * @param {Object} options
 * @param {String} options.type success、info、warning、error の４タイプを指定
 * @param {String} options.title モーダルウィンドウのタイトル
 * @param {String} options.content モーダルウィンドウのコンテンツ（HTML）
 * @param {String} [options.size] モーダルウィンドウのサイズ。`sm`, `lg`, or `fullscreen` を指定。
 * @param {Array} [options.callbacks] モーダルに適用するコールバックの配列
 */
export function modalMsg(options) {
    const defaultOptions = {
        type: '',
        title: 'Thank you',
        content: 'MTAppjQueryをご利用いただきありがとうございます！',
        size: '',
        callbacks: []
    };

    const op = { ...defaultOptions, ...options };

    if (op.type && mtappIcons[op.type]) {
        op.title = `<svg role="img" class="mt-icon--${op.type} mt-icon--sm">${mtappIcons[op.type]}</svg> ${op.title}`;
    }

    const fullscreenHeightFix = op.size === 'fullscreen' ? 'style="max-height: none;"' : '';
    const modalSizeClass = op.size ? `modal-${op.size}` : '';

    const modalHTML = `
        <div id="mtapp-modal-message" class="modal fade" tabindex="-1" aria-labelledby="mtapp-modal-message-title" aria-hidden="true" data-mtapp-type="${op.type}">
            <div id="mtapp-modal-message-dialog" class="modal-dialog modal-dialog-centered ${modalSizeClass}">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="mtapp-modal-message-title" class="modal-title">${op.title}</h4>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" ${fullscreenHeightFix}>
                        ${op.content}
                    </div>
                    <div class="modal-footer">
                        <button type="button" data-bs-dismiss="modal" class="btn btn-default">OK</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    // メッセージが重なって表示されると同じ ID の要素が複数できるため、ID ではなく挿入した要素を参照する
    const modalElement = /** @type {HTMLElement} */ (document.body.lastElementChild);

    if (op.callbacks.length > 0) {
        op.callbacks.forEach((callback) => {
            modalElement.addEventListener(callback.type, callback.action);
        });
    }

    const bsModal = new bootstrap.Modal(modalElement);
    bsModal.show();

    modalElement.addEventListener('hidden.bs.modal', function () {
        document.body.removeChild(modalElement); // モーダルが閉じたらDOMから削除
    });
}
